import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";

// TODO: Maybe come up with a universal way on how we handle errors from the authClient, so we don't have to repeat this logic in every hook.
// React Query wrappers around better-auth's two-factor (TOTP) endpoints. Like useSignIn/useSignUp,
// better-auth resolves with `{ data, error }` rather than throwing, so we re-throw the message to
// drive useMutation's isError/onError states.

type VerifyTotpData = { token: string; user: { id: string; email: string } };
export type VerifyTotpVariables = { code: string; trustDevice?: boolean };
// Verifies a TOTP code. Used both to finish enrolment and to clear the sign-in 2FA challenge.
// `trustDevice` skips the 2FA prompt on this device for 30 days (refreshed on each sign-in).
export function useVerifyTotp(
  options?: UseMutationOptions<VerifyTotpData, unknown, VerifyTotpVariables, unknown>,
) {
  return useMutation({
    mutationFn: async ({ code, trustDevice }: VerifyTotpVariables): Promise<VerifyTotpData> => {
      const { data, error } = await authClient.twoFactor.verifyTotp({ code, trustDevice });
      if (error) {
        throw new Error(betterAuthErrorText(error, "Invalid verification code"));
      }
      return data;
    },
    ...options,
  });
}
